// Ported from the Polaris kit: src/components/ui/bubble/index.js.
// Classes translated from Tailwind 4 to Tailwind 3 and to the polaris-* color
// names (theme/polaris-colors.js). Change the design in the kit first.
import { cva } from 'class-variance-authority';

export { default as Bubble } from './Bubble.vue';
export { default as BubbleContent } from './BubbleContent.vue';
export { default as BubbleGroup } from './BubbleGroup.vue';
export { default as BubbleReactions } from './BubbleReactions.vue';

export const bubbleVariants = cva(
  'gap-1 data-[align=end]:self-end max-w-[80%] data-[variant=ghost]:max-w-full group-data-[align=end]/message:self-end group/bubble relative flex w-fit min-w-0 flex-col',
  {
    variants: {
      variant: {
        default:
          '[&>[data-slot=bubble-content]]:bg-polaris-primary [&>[data-slot=bubble-content]]:text-polaris-primary-foreground [&>[data-slot=bubble-content]:is(button,a):hover]:bg-polaris-primary/80',
        secondary:
          '[&>[data-slot=bubble-content]]:bg-polaris-secondary [&>[data-slot=bubble-content]]:text-polaris-secondary-foreground [&>[data-slot=bubble-content]:is(button,a):hover]:bg-[color:color-mix(in_oklch,var(--polaris-secondary),var(--polaris-foreground)_5%)]',
        muted:
          '[&>[data-slot=bubble-content]]:bg-polaris-muted [&>[data-slot=bubble-content]:is(button,a):hover]:bg-[color:color-mix(in_oklch,var(--polaris-muted),var(--polaris-foreground)_5%)]',
        tinted:
          '[&>[data-slot=bubble-content]]:bg-[color:oklch(from_var(--polaris-primary)_0.93_calc(c*0.4)_h)] dark:[&>[data-slot=bubble-content]]:bg-[color:oklch(from_var(--polaris-primary)_0.3_calc(c*0.4)_h)] [&>[data-slot=bubble-content]]:text-polaris-foreground [&>[data-slot=bubble-content]:is(button,a):hover]:bg-[color:oklch(from_var(--polaris-primary)_0.88_calc(c*0.5)_h)] dark:[&>[data-slot=bubble-content]:is(button,a):hover]:bg-[color:oklch(from_var(--polaris-primary)_0.35_calc(c*0.5)_h)]',
        outline:
          '[&>[data-slot=bubble-content]]:bg-polaris-background [&>[data-slot=bubble-content]]:border-polaris-border [&>[data-slot=bubble-content]:is(button,a):hover]:bg-polaris-muted [&>[data-slot=bubble-content]:is(button,a):hover]:text-polaris-foreground dark:[&>[data-slot=bubble-content]:is(button,a):hover]:bg-polaris-input/30',
        ghost:
          '[&>[data-slot=bubble-content]]:rounded-none [&>[data-slot=bubble-content]]:bg-transparent [&>[data-slot=bubble-content]]:p-0 [&>[data-slot=bubble-content]:is(button,a):hover]:bg-polaris-muted [&>[data-slot=bubble-content]:is(button,a):hover]:text-polaris-foreground dark:[&>[data-slot=bubble-content]:is(button,a):hover]:bg-polaris-muted/50 border-none',
        customer:
          '[&>[data-slot=bubble-content]]:bg-[color:var(--polaris-bubble-customer)] [&>[data-slot=bubble-content]]:text-[color:var(--polaris-bubble-customer-fg)]',
        agent:
          '[&>[data-slot=bubble-content]]:bg-[color:var(--polaris-bubble-agent)] [&>[data-slot=bubble-content]]:text-[color:var(--polaris-bubble-agent-fg)]',
        ai: '[&>[data-slot=bubble-content]]:[background:var(--polaris-bubble-ai)_border-box] [&>[data-slot=bubble-content]]:text-[color:var(--polaris-bubble-ai-fg)]',
        'ai-service':
          '[&>[data-slot=bubble-content]]:[background:var(--polaris-bubble-service)_border-box] [&>[data-slot=bubble-content]]:text-[color:var(--polaris-bubble-service-fg)]',
        'ai-sales':
          '[&>[data-slot=bubble-content]]:[background:var(--polaris-bubble-sales)_border-box] [&>[data-slot=bubble-content]]:text-[color:var(--polaris-bubble-sales-fg)]',
        'ai-ecommerce':
          '[&>[data-slot=bubble-content]]:[background:var(--polaris-bubble-ecommerce)_border-box] [&>[data-slot=bubble-content]]:text-[color:var(--polaris-bubble-ecommerce-fg)]',
        'ai-general':
          '[&>[data-slot=bubble-content]]:[background:var(--polaris-bubble-general)_border-box] [&>[data-slot=bubble-content]]:text-[color:var(--polaris-bubble-general-fg)]',
        'ai-receptionist':
          '[&>[data-slot=bubble-content]]:[background:var(--polaris-bubble-receptionist)_border-box] [&>[data-slot=bubble-content]]:text-[color:var(--polaris-bubble-receptionist-fg)]',
        teammate:
          '[&>[data-slot=bubble-content]]:bg-[color:var(--polaris-bubble-teammate)] [&>[data-slot=bubble-content]]:text-[color:var(--polaris-bubble-teammate-fg)]',
        note: '[&>[data-slot=bubble-content]]:bg-[color:var(--polaris-bubble-note)] [&>[data-slot=bubble-content]]:text-[color:var(--polaris-bubble-note-fg)]',
        failed:
          '[&>[data-slot=bubble-content]]:bg-[color:var(--polaris-bubble-failed)] [&>[data-slot=bubble-content]]:text-[color:var(--polaris-bubble-failed-fg)]',
        destructive:
          '[&>[data-slot=bubble-content]]:bg-polaris-destructive/10 dark:[&>[data-slot=bubble-content]]:bg-polaris-destructive/20 [&>[data-slot=bubble-content]]:text-polaris-destructive [&>[data-slot=bubble-content]:is(button,a):hover]:bg-polaris-destructive/20 dark:[&>[data-slot=bubble-content]:is(button,a):hover]:bg-polaris-destructive/30',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

export const bubbleReactionsVariants = cva(
  'rounded-full ring-[3px] ring-polaris-card bg-polaris-muted shrink-0 gap-1 px-1.5 py-0.5 has-[button]:p-0 text-sm absolute z-10 flex w-fit items-center justify-center',
  {
    variants: {
      side: {
        top: 'top-0 -translate-y-3/4',
        bottom: 'bottom-0 translate-y-3/4',
      },
      align: {
        start: 'left-3',
        end: 'right-3',
      },
    },
    defaultVariants: {
      side: 'bottom',
      align: 'end',
    },
  }
);
